import axios from "../utils/axios";

// ==========================================
// About Home
// ==========================================

export const getAboutHome = async () => {
    const response = await axios.get('/about-home-section');
    return response.data;
};

export const updateAboutHome = async (data) => {
    const response = await axios.put('/about-home-section', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};

// ==========================================
// About Page
// ==========================================

export const getAboutPage = async () => {
    const response = await axios.get('/about-page');
    return response.data;
};

export const updateAboutPage = async (data) => {
    const response = await axios.put('/about-page', data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};
